import { makeStyles } from "@material-ui/core/styles";
import { secondary } from "../../../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(5),
  },
  spinner: {
    color: secondary,
  },
}));

export default useStyles;
